import { SVGComponentProps } from "./utils/Types"

const HamburgerMenuIcon = ({ width = 20, height = 20, className }: SVGComponentProps) => {
    return (
<svg
    fill="currentColor"
    className={`text-current ${className}`}
    width={width}
    height={height}
    stroke="currentColor"
    viewBox="0 0 24 24">
    <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4 6h16M4 12h16M4 18h16" />
</svg>
    )
}

export default HamburgerMenuIcon